// play now button page,where start quiz with category

import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "./Navbar";
import coin from '../assets/earn-coin.svg';
import Adsense from "./Adsense";

function Playquiz() {
 
  const { name } = useParams();
   const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <div className="main-div2">
          <div className="container mt-3">
            <div className="">
              <Navbar />
            </div>
                {/* <div className="mt-2">
            <Adsense slot="6300978111"/>
              </div> */}
            <div className="card p-4 text-center mt-4 mb-4">
              {/* 🔥 Ahiya dynamic category name */}
              <h5 >{name.toUpperCase()}</h5>

              <p>Play & WinCoin <span><img src={coin} alt="Coin" height={'15px'} /></span> 1000</p>

              <button className="play-btn  mt-3"   onClick={() => navigate(`/quiz/${name}`)}>Play Now</button>

              {/* <p className="mt-2">Or</p> */}

              {/* <button className="btn btn-warning">Play as Guest</button> */}

              <ul className="text-start mt-5 d-flex flex-column gap-2">
                <li>You got 120 seconds to answer all questions</li>
                <li>Answer as many questions as you can</li>
                <li>For Every Correct answer you will get 100 points and will loose -100 points on every Incorrect answer</li>
                <li>You can take help by using the lifelines present in the contest.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Playquiz;
